var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("MetaLead Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Kanal Sayısı")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.metaLeadChannelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "metaLeadChannelCount", $$v)
                },
                expression: "featureForm.metaLeadChannelCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Otomasyon ile Yönetim"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.metaLeadAutomationManage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "metaLeadAutomationManage", $$v)
                },
                expression: "featureForm.metaLeadAutomationManage",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Ticket ile Yönetim"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.metaLeadTicketManage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "metaLeadTicketManage", $$v)
                },
                expression: "featureForm.metaLeadTicketManage",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }